import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { Footer } from './components/shared';
import { HomePage, AboutPage, ContactPage, ServicePage, WorkPage } from './components/pages';
import { useSettings } from './context/SettingsContext';

export default function App() {
  const { t } = useSettings();

  return (
    <>
      <a href="#main" className="skip-link">
        {t.skipToContent}
      </a>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact/:redirectReason" element={<ContactPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/work" element={<WorkPage />} />
      </Routes>
      <Footer />
    </>
  );
}
